module.exports = __webpack_public_path__ + "01_mole.ee55b9c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/01_mole.png
// module id = cDWO
// module chunks = 0